import { useAITranslatorSettingsLocal } from "./use-ai-translator-settings-local"
import { defaultSettings } from "../constants/translator-defaults"

export function useAITranslatorSettings() {
  const { settings, updateSettings } = useAITranslatorSettingsLocal()

  function resetSettings() {
    updateSettings({ ...defaultSettings, selectedLanguages: [defaultSettings.selectedLanguage] })
  }

  return {
    settings,
    resetSettings,
  }
}
